import { useState } from "react";
import Navbar from "../../components/Navbar/Navbar";

import "./Resources.css";

function Resources() {
  const [media, setMedia] = useState("");

  return (
    <div className="content">
      <Navbar />
      <div className="info">
        <form className="social">
          <select
            value={media}
            onChange={(e) => {
              setMedia(e.target.value);
            }}
            name="media"
          >
            <option value="events">Choir</option>
            <option value="sermons">Youth</option>
            <option value="bibletudy">Singles</option>
          </select>
        </form>
        <hr />
        {media === "events" ? (
          <events />
        ) : media === "sermons" ? (
          <bibleStudy />
        ) : (
          <sermons />
        )}
      </div>
    </div>
  );
}

export default Resources;
